/**
 * Menu APIs expose likes as either a count (list endpoints) or an array of
 * user ids (raw documents / some detail payloads).
 */
export function resolveLikesCount(item) {
  if (!item) return 0;
  if (typeof item.likes === 'number' && Number.isFinite(item.likes)) {
    return item.likes;
  }
  if (Array.isArray(item.likes)) {
    return item.likes.length;
  }
  return 0;
}

export function resolveHasLiked(item, user) {
  if (!item) return false;
  if (typeof item.isLiked === 'boolean') return item.isLiked;
  const userId = user?.sub;
  if (userId && Array.isArray(item.likes)) {
    return item.likes.includes(userId);
  }
  return false;
}
